import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";


import {
  Header,
  CarInfo,
  AddCars,
  Space,
  Text,
  CarDetailsPopup,
} from "../../Components/Index";

import { useCars } from "../../Context/CarContext";

function Cars() {
  const navigate = useNavigate();

  const {
    cars,
    loading,
    error,
    refreshCars,
    selectCar,
    deleteCar,
  } = useCars();

  // =========================
  // جزئیات ماشین
  // =========================

  const [detailsCarId, setDetailsCarId] = useState(null);

  const handleDetailsCar = (carId) => {
    setDetailsCarId(carId);
  };

  const handleCloseDetails = () => {
    setDetailsCarId(null);
  };

  const detailsCar =
    cars.find(
      (car) => String(car.id) === String(detailsCarId)
    ) || null;

  useEffect(() => {
    refreshCars().catch(() => {
      // Error is already handled in CarContext and stored in error state
      // This catch prevents unhandled promise rejection warning
    });
  }, [refreshCars]);

  // =========================
  // انتخاب ماشین
  // =========================

  const handleCarSelect = (carId) => {
    selectCar(carId);
  };

  // =========================
  // ویرایش ماشین
  // =========================

  const handleEditCar = (carId) => {
    if (!carId) {
      console.error("CAR ID NOT FOUND");
      return;
    }

    navigate(`/AddCars/${carId}`);
  };

  // =========================
  // حذف ماشین
  // =========================

  const handleDeleteCar = async (carId) => {
    const confirmed = window.confirm(
      "آیا از حذف این خودرو مطمئن هستید؟"
    );

    if (!confirmed) {
      return;
    }

    try {
      await deleteCar(carId);
    } catch (err) {
      console.error(
        "DELETE CAR ERROR:",
        err
      );
    }
  };

  // =========================
  // Loading
  // =========================

  if (loading) {
    return (
      <>
        <Header
          hideR=""
          LinkR="/"
          Text="ماشین ها"
        />

        <div className="cars-loading">
          <Space size="xl" />

          <Text
            position="center"
            FontSize="lg"
          >
            در حال بارگذاری ماشین‌ها...
          </Text>

          <Space size="xl" />
        </div>
      </>
    );
  }

  // =========================
  // Error
  // =========================

  if (error) {
    return (
      <>
        <Header
          hideR=""
          LinkR="/"
          Text="ماشین ها"
        />

        <div className="cars-error">
          <Space size="xl" />

          <Text
            position="center"
            FontSize="lg"
            color="red"
          >
            {error}
          </Text>

          <Space size="lg" />

          <Link
            to="/Cars"
            onClick={refreshCars}
            className="retry-text"
          >
            دوباره تلاش کنید
          </Link>

          <Space size="xl" />
        </div>
      </>
    );
  }

  // =========================
  // Main
  // =========================

  return (
    <>
      <Header
        hideR=""
        LinkR="/"
        Text="ماشین ها"
      />

      {/* =========================
          لیست ماشین‌ها
      ========================= */}

      <div className="cars-list">

        {cars.length === 0 ? (
          <Text
            position="center"
            FontSize="md"
            color="gray"
          >
            هیچ ماشینی ثبت نشده است
          </Text>
        ) : (

          cars.map((car) => (
            <div
              key={car.id}
              className="cars-list__item"
            >

              <CarInfo
                carId={car.id}

                Src={car.Src}
                Km={car.Km}
                CarModel={car.CarModel}
                CarColor={car.CarColor}
                ProductionYear={
                  car.ProductionYear
                }

                Plate1={car.Plate1}
                Plate2={car.Plate2}
                Plate3={car.Plate3}
                End={car.End}

                selectable

                onSelect={() =>
                  handleCarSelect(car.id)
                }

                showMoreMenu

                // =========================
                // ویرایش
                // =========================

                onEdit={() =>
                  handleEditCar(car.id)
                }

                // =========================
                // حذف
                // =========================

                onDelete={() =>
                  handleDeleteCar(car.id)
                }

                // =========================
                // جزئیات
                // =========================

                onDetails={() =>
                  handleDetailsCar(car.id)
                }

                onService={() =>
                  navigate("/PlateCapture", { state: { selectedVehicleId: car.id, vehicle: car } })
                }

              />

              <Space />

            </div>
          ))

        )}

        {/* =========================
            اضافه کردن ماشین
            (کارت مشترک AddCars؛ کلیک روی کل کارت به فرم
            ثبت موجود در /AddCars می‌رود؛ wrapper یکسان با
            کارت‌های ماشین تا عرض دقیقاً برابر شود)
        ========================= */}

        <div className="cars-list__item">
          <AddCars />
        </div>

        <Space size="lg" />

      </div>

      {/* =========================
          Car Details Popup
      ========================= */}

      <CarDetailsPopup
        car={detailsCar}
        isOpen={detailsCar !== null}
        onClose={handleCloseDetails}
      />

    </>
  );
}

export default Cars;
